import { useState } from 'react';
import { useLayoutContext } from '../../Context/Layout.context';
import { revokeExamTaskGroupSolution } from '../../services/scoringModel/scoringModel.service';
import { ButtonOne } from '../ButtonOne/ButtonOne.component';
import { Prompt, promptType } from '../Prompt/Prompt.component';

export const RevokeControlProcess: React.FC<{
  examTaskGroupSolutionId: string;
  examTaskGroupsolutionScoreId: string;
  onRevoked: () => void;
}> = (props) => {
  const { setIsLoader } = useLayoutContext();
  const [prompt, setPrompt] = useState<{
    open: boolean;
    type: promptType;
    mainText?: string;
    mainActionButtonText?: string;
    onCancel?: () => void;
    onConfirm?: () => void;
  }>({ open: false, type: 'confirmation' });

  const hidePrompt = () => {
    setPrompt({ open: false, type: 'confirmation' });
  };

  const displaySuccessPrompt = () => {
    setPrompt({
      open: true,
      type: 'success',
      mainText: `Wycofanie RGZ: ${props.examTaskGroupsolutionScoreId} z procesu kontrolnego zakończone sukcesem.`,
      mainActionButtonText: 'powrót do listy',
      onConfirm: () => {
        hidePrompt();
        props.onRevoked();
      },
    });
  };

  const displayErrorPrompt = () => {
    setPrompt({
      open: true,
      type: 'error',
      mainText: `Wycofanie RGZ: ${props.examTaskGroupsolutionScoreId} z procesu kontrolnego nie powiodło się. Spróbuj ponownie później.`,
      mainActionButtonText: 'powrót',
      onConfirm: hidePrompt,
    });
  };

  const onConfirm = () => {
    setIsLoader(true);
    revokeExamTaskGroupSolution(props.examTaskGroupSolutionId)
      .then(displaySuccessPrompt, displayErrorPrompt)
      .catch(displayErrorPrompt)
      .finally(() => setIsLoader(false));
  };

  const displayConfirmationPrompt = () => {
    setPrompt({
      open: true,
      type: 'confirmation',
      mainText: `Czy na pewno chcesz wycofać RGZ: ${props.examTaskGroupsolutionScoreId} z procesu kontrolnego?`,
      mainActionButtonText: 'tak',
      onCancel: hidePrompt,
      onConfirm: onConfirm,
    });
  };

  return (
    <>
      <ButtonOne
        variant="outlined"
        size="small"
        style={{
          marginLeft: '45%',
          color: '#FFFFFF',
          background: '#BC0000',
          borderColor: '#BC0000',
        }}
        onClick={displayConfirmationPrompt}
      >
        WYCOFAJ
      </ButtonOne>
      {prompt.open && <Prompt {...prompt} />}
    </>
  );
};
